// Single source of truth for the main site navigation.
// Consumed by Header (desktop), Mobile Menu and Footer — edit ONLY here.
// `footer: false` hides an item from the footer (Home, by design).
import { NAV } from "@/constants/testIds";

export const MAIN_NAV = [
  { to: "/",          label: "Home",      tid: NAV.home,      footer: false },
  { to: "/about",     label: "About",     tid: NAV.about,     footer: true },
  { to: "/services",  label: "Services",  tid: NAV.services,  footer: true },
  { to: "/blog",      label: "Blog",      tid: NAV.blog,      footer: true },
  { to: "/support",   label: "Support",   tid: NAV.support,   footer: true },
  { to: "/contact",   label: "Contact",   tid: NAV.contact,   footer: true },
];
